"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.InitPageSetup = void 0;
var initPageSetup_1 = require("./initPageSetup");
Object.defineProperty(exports, "InitPageSetup", { enumerable: true, get: function () { return initPageSetup_1.InitPageSetup; } });
var logger_1 = require("./logger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
